import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import SectionTitleWithHr from "../../components/SectionTitleWithHR/SectionTitleWithHr";
import LabelValueDisplay from "../../components/LabelValue/LabelValueDisplay";
import { useEffect, useState } from "react";
import AddButton from "../../components/AddButton/AddButton";
import _ from "lodash";
import { applyGoldenConfig, backupConfigData, backupConfigNow } from "../../../../../actions/Users/authenticateInventory";
import { convertDateTimeIntoTimezone } from "../../../../../utils/util";
import { DEFAULT_DATE_FORMAT, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../../../../utils/constants";
import { CONFIRM_DIALOG_TITLE } from "../../../../../config";
import { GET_BACKUP_CONFIG_DATA, BACKUP_CONFIG_NOW, APPLY_GOLDEN_CONFIG } from "../../../../../actions/types";
import { Box, Grid } from "@mui/material";
import { compare } from "compare-versions";
import AddEditInterfaceModal from "../../components/Modals/AddEditInterfaceModal";
import save_config_icon from '../../../../../asset/image/save_config_icon.svg';
import upload_config_icon from '../../../../../asset/image/upload_config_icon.svg';

const UploadConfig = (props) => {
    const { getVesselsListing, backupConfigurationData, row, backupConfigData, backupConfigNowData, applyGoldenConfigData, userTimezone, deviceName, setConfirmDialog, backupConfigNow, applyGoldenConfig, setOpen } = props;
    const [configOptions, setConfigOptions] = useState<any>([]);
    const [selectedConfig, setSelectedConfig] = useState<any>({});
    const [fileName, setFileName] = useState("");
    const dispatch = useDispatch();
    const currentEOSversion = !_.isEmpty(row.current_EOS_version) ? row.current_EOS_version.toLowerCase().startsWith("v") ? row.current_EOS_version : "v" + row.current_EOS_version : "";
    const [openConfigPopup, setOpenConfigPopup] = useState(false);
    const [action, setAction] = useState('');

    useEffect(() => {
        if (!_.isEmpty(getVesselsListing)) {
            let data = getVesselsListing.hasOwnProperty("locations") && Array.isArray(getVesselsListing.locations) ? getVesselsListing.locations : [];
            let _k4Ids: any = []
            const vessels = data?.map((vs) => {
                _k4Ids.push(vs.id);
                return { label: vs.name, id: vs.id }
            })
            let sitesIds = _k4Ids.join(',')
            let status = "completed"
            sitesIds && row?.['dpId'] && backupConfigData(sitesIds, -1, -1, '', 'create_time', 'desc', '', row['productType'], '', true, status, row?.['dpId']);
        }
    }, [getVesselsListing])

    useEffect(() => {
        if (!_.isEmpty(backupConfigurationData)) {
            const data = backupConfigurationData?.result;
            setConfigOptions(data?.filter((ele) => ele.id)?.map((ele) => {
                return { label: ele.config_name, id: ele.id, details: ele }
            }));
            dispatch({ type: GET_BACKUP_CONFIG_DATA, payload: {} })
        }
        if (!_.isEmpty(backupConfigNowData) && backupConfigNowData.success == true) {
            setOpen(false);
            dispatch({ type: BACKUP_CONFIG_NOW, payload: {} })
        }
        if (!_.isEmpty(applyGoldenConfigData)) {
            setOpen(false);
            dispatch({ type: APPLY_GOLDEN_CONFIG, payload: {} })
        }
    }, [backupConfigurationData, backupConfigNowData, applyGoldenConfigData])

    const handleUpload = () => {
        setConfirmDialog({
            isOpen: true,
            title: CONFIRM_DIALOG_TITLE,
            subTitle: "Configuration change needs server reboot and device will go offline for around 10-15 mins.\n\nConfirm to apply the configuration changes on the device " + deviceName + " ?",
            onConfirm: () => {
                const payload = {
                    site_id: row['k4Id'],
                    device_id: row['deviceId'],
                    config_id: selectedConfig?.id
                }
                applyGoldenConfig(payload);
            }
        })
        setOpenConfigPopup(false);
    };

    const handleSaveConfig = () => {
        setConfirmDialog({
            isOpen: true,
            title: CONFIRM_DIALOG_TITLE,
            subTitle: "Confirm to download the configuration for " + deviceName + " ?",
            onConfirm: () => {
                backupConfigNow(row["k4Id"], row["deviceId"], deviceName, fileName)
            }
        })
        setOpenConfigPopup(false);
    };

    const handleDisabled = () => {
        if(action === 'Upload') {
            return (
                // row?.['konnect_status'] != 'STATUS_CONNECTED' ||
                _.isEmpty(selectedConfig) ||
                _.isEmpty(selectedConfig?.details?.software_version) ||
                _.isEmpty(currentEOSversion) ||
                compare(selectedConfig?.details?.software_version, currentEOSversion, '>')
            )
        }
        if(action === 'Save') {
            return (
                !fileName || configOptions?.some((config) => config.label === fileName)
            )
        }
    }


    return (
        <div className="system-upload-configuration">
            <SectionTitleWithHr title="Configuration" />

            <div className="system-tab-grid">
                <div></div>
                <div></div>
                {/* <LabelValueDisplay
                    label="File Name"
                    isInput
                    value={fileName}
                    onChange={(e) => setFileName(e.target.value)}
                    placeholder="Enter filename"
                    error={configOptions?.some((config) => config.label === fileName) ? "This config name is already in use" : ""}
                /> */}
                <div></div>
                <AddButton
                    onAddClick={() => {setOpenConfigPopup(true); setAction('Save'); setFileName('');}}
                    addLabel="Save Configuration"
                    maxWidth="220px"
                    icon={save_config_icon}
                    // disabled={!fileName || configOptions?.some((config) => config.label === fileName)}
                />

                <div></div>
                <LabelValueDisplay label="Software Version" value={row['current_EOS_version']} />
                <LabelValueDisplay label="Configuration Creation Date" value={convertDateTimeIntoTimezone(row['create_time'], userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)} />
                <AddButton onAddClick={() => {setOpenConfigPopup(true); setAction('Upload'); setSelectedConfig({})}} addLabel="Upload Configuration" maxWidth="220px" icon={upload_config_icon}
                    disabled={
                        // row?.['konnect_status'] != 'STATUS_CONNECTED' ||
                        _.isEmpty(currentEOSversion)
                    }
                 />
            </div>
            {_.isEmpty(currentEOSversion) && <div className="domain_name_validation_err_message">Device software version needed for Upload Configuration.</div>}

            {/* {
                !_.isEmpty(selectedConfig?.details) && !_.isEmpty(selectedConfig?.details?.software_version) && !_.isEmpty(currentEOSversion) && compare(selectedConfig?.details?.software_version, currentEOSversion, '>')
                    ?
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Grid className="ticket-description-alert">Selected config EOS version is higher than the target device current EOS version</Grid>
                        <br />
                    </Grid>
                    : null
            } */}
            {/* {
                !_.isEmpty(selectedConfig?.details)
                ?
                    <>
                        <SectionTitleWithHr
                            title="Selected Configuration details"
                            showRadio={false}
                        /><br />
                        <Grid container>
                            <Grid xs={4} sm={4} md={4} lg={4}>
                                <LabelValueDisplay
                                    label="Device"
                                    value={selectedConfig?.details?.device_name}
                                />
                            </Grid>
                            <Grid xs={4} sm={4} md={4} lg={4}>
                                <LabelValueDisplay
                                    label="EOS version"
                                    value={selectedConfig?.details?.software_version}
                                />
                            </Grid>
                            <Grid xs={4} sm={4} md={4} lg={4}>
                                <LabelValueDisplay
                                    label="Creation Date"
                                    value={convertDateTimeIntoTimezone(selectedConfig?.details?.create_time, userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS)}
                                />
                            </Grid>
                        </Grid>
                    </>
                    : null
            } */}
            <AddEditInterfaceModal
                open={openConfigPopup}
                onClose={() => { setOpenConfigPopup(false); setSelectedConfig({}); setFileName(''); }}
                onSave={() => { action == 'Save' ? handleSaveConfig() : handleUpload() }}
                saveText={action}
                disableSave={handleDisabled()}
                title={'Action'}
                layout={action == 'Save' ? [
                    {
                        columns: [
                            {
                                component: (
                                    <LabelValueDisplay
                                        label="File Name"
                                        isInput
                                        value={fileName}
                                        onChange={(e) => setFileName(e.target.value)}
                                        placeholder="Enter filename"
                                        error={configOptions?.some((config) => config.label === fileName) ? "This config name is already in use" : ""}
                                    />
                                ),
                                gridSize: 12,
                            },
                        ],
                    },
                    {
                        columns: [
                            {
                                component: (
                                    <LabelValueDisplay
                                        label="Software version"
                                        value={row?.['current_EOS_version']}
                                    />
                                ),
                                gridSize: 12,
                            },
                        ],
                    },
                    {
                        columns: [
                            {
                                component: (
                                    <>
                                        <span className="value-text">The file will be available in configuration uploads.</span>
                                    </>
                                ),
                                gridSize: 12,
                            },
                        ],
                    },
                ] : [
                    {
                        columns: [
                            {
                                component: (
                                    <LabelValueDisplay
                                        label="Upload Device Configuration"
                                        isDropdown
                                        dropdownOptions={configOptions?.map(config => config.label)}
                                        value={selectedConfig?.label}
                                        onChange={(e) => {
                                            const selected = configOptions?.filter(config => config.label)?.find(opt => opt.label === e.target.value);
                                            setSelectedConfig(selected);
                                        }}
                                        placeholder="Select config type"
                                        // maxWidth='160px'
                                    />
                                ),
                                gridSize: 12,
                            },
                        ],
                    },
                        {
                            columns: [
                                {
                                    component: (

                                        !_.isEmpty(selectedConfig?.details) && !_.isEmpty(selectedConfig?.details?.software_version) && !_.isEmpty(currentEOSversion) && compare(selectedConfig?.details?.software_version, currentEOSversion, '>')
                                            ?
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <Grid className="ticket-description-alert">Selected config EOS version is higher than the target device current EOS version.</Grid>
                                                <br />
                                            </Grid>
                                            : null
                                    ),
                                    gridSize: 12,
                                },
                            ],
                        },
                    {
                        columns: [
                            {
                                component: (
                                    <Box height="21px" />
                                ),
                                gridSize: 12,
                            }
                        ]
                    },
                    {
                        columns: [
                            {
                                component: (
                                    <>
                                        <span className="value-text">The selected file will be loaded to this configuration.</span>
                                    </>
                                ),
                                gridSize: 12,
                            },
                        ],
                    }
                ]}
            />
        </div>
    )
}

const mapStateToProps = (state) => ({
    backupConfigurationData: state.authReducer.backupConfigData,
    backupConfigNowData: state.authReducer.backupConfigNow,
    applyGoldenConfigData: state.authReducer.applyGoldenConfig,
    userTimezone: state.authReducer.userTimezone,
    getVesselsListing: state.authReducer.getVesselsListing,
});

export default withRouter(
    connect(mapStateToProps, { backupConfigData, backupConfigNow, applyGoldenConfig })(UploadConfig)
);